import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2, Text } from '@blueprint/ui';

type HomeWorthProps = {
    isLoggedIn: boolean;
};

const marginRight = '12px';
const maxWidth = '721px';

export const Wrapper = styled.div<HomeWorthProps>(
    ({ theme: { mq }, isLoggedIn }) =>
        css`
            width: 100%;
            display: flex;
            flex-direction: column;

            ${mq.medium} {
                margin-right: ${isLoggedIn ? '0' : `${marginRight}`};
                flex-direction: ${isLoggedIn ? 'row-reverse' : 'column'};
                max-width: ${isLoggedIn ? '100%' : `${maxWidth}`};
                align-items: ${isLoggedIn ? 'flex-start' : 'auto'};
            }
        `
);

export const Image = styled.img<HomeWorthProps>(
    ({ theme: { mq }, isLoggedIn }) =>
        css`
            display: flex;
            max-width: 100%;
            width: 100%;
            height: auto;

            ${mq.medium} {
                width: ${isLoggedIn ? '60%' : '100%'};
            }
        `
);

export const MainContent = styled.div<HomeWorthProps>(
    ({ theme: { mq, spacing }, isLoggedIn }) =>
        css`
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: ${spacing['16px']} 0 ${spacing['24px']} 0;

            ${mq.medium} {
                margin-right: ${isLoggedIn ? `${spacing['24px']}` : '0'};
                padding-top: ${isLoggedIn ? '0' : 'auto'};
            }

            ${mq.large} {
                padding: ${spacing['24px']} 0;
                width: ${isLoggedIn ? '50%' : '75%'};
                margin-right: ${isLoggedIn ? `80px` : '0'};
            }
        `
);

export const Heading = styled(Heading2)<HomeWorthProps>(
    ({ theme: { spacing } }) =>
        css`
            margin-bottom: ${spacing['8px']};
        `
);

export const Description = styled(Text)<HomeWorthProps>(
    ({ theme: { spacing, mq }, isLoggedIn }) =>
        css`
            margin-bottom: ${spacing['24px']};

            ${mq.medium} {
                margin-bottom: ${isLoggedIn
                    ? `${spacing['16px']}`
                    : `${spacing['24px']}`};
            }

            ${mq.large} {
                margin-bottom: ${spacing['24px']};
                max-width: 500px;
            }
        `
);
